module.exports = __webpack_public_path__ + "static/media/loader.5270f7df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/loader.svg
// module id = 572
// module chunks = 0